import Logo from './Logo';
import FilterContainer from '../container/FilterContainer';

const Header = () => (
  <div className="header main">
    <Logo />
    <FilterContainer />
  </div>
);

export default Header;
